import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=493cc6d9"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jenniferhoude/Herd/fertilizer-canada-2024-wp/wp-content/plugins/baytek-agronomist-directory/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('493cc6d9')) {
      api.createRecord('493cc6d9', component.options)
    } else {
      api.reload('493cc6d9', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=493cc6d9", function () {
      api.rerender('493cc6d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/source/vue/components/layouts/Home.vue"
export default component.exports